import tr from './assets/i18n/tr.json';
import en from './assets/i18n/en.json';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import i18n from './i18n';

import './validators';

Vue.use(VeeValidate, {
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  events: 'input|blur',
  dictionary: {
    tr: tr,
    en: en,
  },
});
